import type { I18nFn } from '#/i18n/types/I18nFn';

export function LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_TITLE(i18n: I18nFn) {
  return {
    ALL: i18n('Everything'),
    JOB: i18n('Jobs'),
    INTERNSHIP: i18n('Internships'),
    VOLOP: i18n('Volunteer Opportunities'),
    ORG: i18n('Organizations'),
    EVENT: i18n('Events'),
    RECIPES_FOR_ACTION: i18n('Recipes for Action'),
  };
}
